import { createAction, props, union } from '@ngrx/store';

import { SearchState } from '../../interfaces/index';

export const setSearch = createAction('[Timetable] setSearchTerms', props<Partial<SearchState>>());
export const clearSearch = createAction('[Timetable] clearSearchTerms');

const all = union({
  setSearch,
  clearSearch,
});

export type SearchActionsUnion = typeof all;
